import React, { Component } from 'react';
import CategoriesDetailsRC from '../components/ClientPortal/ClientportalDashboardComponents/ClientportalCategoriesComponents/CategoriesDetailsRC';
import { BankUserContext } from '../bankUserContext';
import { WithRouterProps, withRouter } from '../components/shared/WithRouter';

class ClientPortalCategoriesDetails extends Component<WithRouterProps<unknown>> {
    static contextType = BankUserContext; 
    context: React.ContextType<typeof BankUserContext> | undefined;

    componentDidMount(): void {
    }

    render() {
        const categoryId = this.props?.params?.categoryId;
        const clientProductId = this.props?.params?.clientProductId;
        const screenType = this.props?.params?.screenType;
        const clientId = this.props?.params?.clientId
        return (
            <>
            <div className="container-fluid p-0">
                <CategoriesDetailsRC clientId={clientId}  categoryId={categoryId} clientProductId={clientProductId} screenType={screenType} location={this.props.location}/>
                </div>
            </>
        );
    }
}

export default withRouter<WithRouterProps<unknown>>(ClientPortalCategoriesDetails)
;